import { initConfig } from '@cian/config/browser';
import { initLogger } from '@cian/logger/browser';
import { init as initTelemetry, setup as setupTelemetry } from '@cian/telemetry/browser';
import { init as initHttpApi, setup as setupHttpApi } from '@cian/http-api/browser';
import { init as initWeb } from '@cian/web/browser';
import { init as initGlobalBehaviors } from '@cian/global-behaviors/browser';
import { initGlobalEventsLogs } from '@cian/events-log';

export function setupDependencies() {
  setupTelemetry();
  setupHttpApi({});
}

export function initDependencies() {
  initConfig();
  initLogger();
  initTelemetry();
  initHttpApi();
  initWeb();
  initGlobalBehaviors();
  initGlobalEventsLogs();
}
